import * as ko from 'knockout';
import type { CardsWallEndpointType } from '../../../cards-wall/cardsWallUtils';
import type { ReplyCardViewModel } from '../../../reply-card/ko/replyCardViewModel';
import type { CollectionSliderRuntimeModel } from './collectionSliderRuntimeModel';

export class CollectionSliderRuntimeViewModel {
    public readonly cards: ko.ObservableArray<ReplyCardViewModel>;
    public readonly preloadedItems: ko.Observable<number>;

    public readonly endpointType: ko.Observable<CardsWallEndpointType>;

    constructor(model: CollectionSliderRuntimeModel) {
        this.cards = ko.observableArray<ReplyCardViewModel>([]);
        this.preloadedItems = ko.observable<number>(model?.preloadedItems);
        this.endpointType = ko.observable<CardsWallEndpointType>(model.model.endpointType);
    }
}
